import createSmartIntersector from "../../utils/createSmartIntersector";
import * as mediaPool from "./_mediaPool";
import { controlSpacer } from "./utils";

const TIKTOK_CLASS = "tiktok-embed";
const LAZY_TIKTOK_CLASS = "tiktok_lazy_shortcode";

function onIntersect(entry) {
    const { target } = entry;

    function onFreeSlot(resourceID) {
        target.classList.add(TIKTOK_CLASS);
        target.classList.remove(LAZY_TIKTOK_CLASS);

        function releaseTiktokResource() {
            mediaPool.release(resourceID);
            const iframe = target.querySelector("iframe");
            let loaded = false;

            function setLoaded() {
                if (loaded) {
                    return;
                }
                loaded = true;
                const container = target.closest(".rm-embed-container.rm-loading");
                if (!container) {
                    return;
                }
                container.classList.remove("rm-loading");
                container.classList.add("rm-loaded");
                setTimeout(() => {
                    controlSpacer(target, container);
                }, 1000);
            }

            iframe.addEventListener("load", setLoaded);
            setTimeout(setLoaded, 1000);
        }

        if (window.tiktokEmbed && "lib" in window.tiktokEmbed) {
            window.tiktokEmbed.lib.render([target]).then(releaseTiktokResource);
        } else {
            setTimeout(releaseTiktokResource, 3000);
        }
    }
    mediaPool.request(1700).then(onFreeSlot);
}

export default function loadLazyReddit(intersectionObserverProvider) {
    createSmartIntersector(intersectionObserverProvider, {
        onIntersect,
        initialThreshold: 400,
        selector: ".tiktok_lazy_shortcode",
        dependencySrc: "https://www.tiktok.com/embed.js",
    });
}
